import React, { useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';

export const AgmStatus = ({ ballotId, onAgmStatusUpdate }) => {
    const [connection, setConnection] = useState(null);

    useEffect(() => {
        const connectionUrl = `hubs/agm?b=${ballotId}`
        const newConnection = new signalR.HubConnectionBuilder()
            .withUrl(connectionUrl)
            .withAutomaticReconnect()
            .build();

        setConnection(newConnection);
    }, []);

    useEffect(() => {
        if (connection) {
            connection.start()
                .then(() => {
                    connection.on('agmStatusUpdate', payload => {
                        onAgmStatusUpdate(payload.oldStatus, payload.newStatus)
                    })

                    connection.on('connectionRejected', message => {
                        // Cancel auto reconnect
                        connection.stop()
                    })

                    // Subscribe for AGM updates
                    connection.send('subscribe')
                })
                .catch(err => console.error(err));
        }
    }, [connection, onAgmStatusUpdate]);

    return (
        <></>
    );
}